import React, { Component } from 'react'
import { 
  SelectInstructions, 
  SelectProgressBar, 
  DistrictDropdown,
  SelectNav,
} from './'
import { Row } from 'reactstrap'

class SelectDistrict extends Component {
  state = {
    district: ''
  }

  selectDistrict = ({target}) => this.setState({district: target.value})

  render() {
    const { district } = this.state
    const { districts } = this.props
    const { selectDistrict } = this

    return (
      <Row className='selector-card' noGutters>
        <h4>Manage District Licenses</h4>
        <SelectInstructions>
          Select the school district you want to manage, then click 'Next' to continue.
        </SelectInstructions>
        <SelectProgressBar 
          state={this.state} 
          selectorName='district'
        />
        <DistrictDropdown
          selectedDistrict={districts && districts[district]}
          disabled={false}
          districts={districts}
          selectOption={selectDistrict}
        />
        <SelectNav 
          nextLink={district && `/users/licenses/districts/${district}`}
        />
      </Row>
    )
  }
}

export default SelectDistrict


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectDistrict.js